import script from "./UniversalPreviewPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./UniversalPreviewPrint.vue?vue&type=script&setup=true&lang=js"

import "./UniversalPreviewPrint.vue?vue&type=style&index=0&id=3452ad9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3452ad9a"]])

export default __exports__